import { useEffect, useMemo } from 'react';

import { useField, useForm } from 'react-final-form';

import { useIsSecuritySunsetEnabled } from 'features/organization/security-insights/hooks/useIsSecuritySunsetEnabled';
import { useGetWebhookCategoriesQuery } from 'hooks/queries/notifications';

import { RffSelect } from '@cast/shared-rff-ui';

export const OperationSelect = () => {
  const { categories } = useGetWebhookCategoriesQuery();
  const isSecuritySunsetEnabled = useIsSecuritySunsetEnabled();

  const categoryField = useField('category');
  const form = useForm();

  const options = useMemo(() => {
    const subcategories = categories?.find(
      (c) => c.value === categoryField.input.value
    )?.subcategories;
    return Object.entries(subcategories || {})
      .filter(([key]) => key !== 'best-practices') // SEC doesn't support it at the moment
      .filter(([key]) => !isSecuritySunsetEnabled || key !== 'anomalies') // with SEC sunset anomalies will be gone
      .map(([key, value]) => ({
        title: value,
        value: key,
      }));
  }, [categories, categoryField.input.value, isSecuritySunsetEnabled]);

  useEffect(() => {
    form.change('subcategory', options[0]?.value ?? '');
  }, [form, options]);

  if (
    !categoryField.input.value || // If a category without a value is selected (e.g. "Other")
    !options?.length || // If the selected category has no subcategories (e.g. "All")
    options.length === 1 // If only one option is available
  ) {
    return null;
  }

  return (
    <RffSelect
      testId="alert-subcategory-select"
      applySortingWhileSearching={false}
      label="Operation"
      name="subcategory"
      options={options}
      optionLabel="title"
      optionValue="value"
      renderValue="title"
    />
  );
};
